class FeatureCards extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-feature-card]'));

    this.cards.forEach((card) => {
      const trigger = card.querySelector('[data-feature-expand]');
      const extra = card.querySelector('[data-feature-expand-content]');

      if (!trigger || !extra || extra.textContent.trim() === '') {
        trigger?.remove();
        return;
      }

      trigger.addEventListener('click', () => {
        const isExpanded = card.classList.toggle('is-expanded');
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    });
  }
}

customElements.define('feature-cards', FeatureCards);
